import * as React from "react"
import {ListItemButton, ListItemText, useTheme} from "@mui/material";
import {alpha} from "@mui/material/styles";

import {useActiveLink} from "../../@hooks";
import {dsColorNew} from "@palette";
import NavBadge from "../NavBadge";


export default function AppPopoverNavItem({ path, title, badge = null }) {
    const theme = useTheme()
    const { active } = useActiveLink(path)

    const textConfig = {
        noWrap: true,
        sx: {
            width: 'auto',
            fontSize: '1.1rem',
            lineHeight: '16px',
            textAlign: 'left',
            color: active ? 'primary.main' : dsColorNew.textDark,
            fontWeight: active ? 'fontWeightMedium' : 400,
        }
    }

    return <ListItemButton sx={{
        borderRadius: '8px',
        py: 0.75,
        px: 1.5,
        '&:hover': { backgroundColor: dsColorNew.hoverBgLight },
        ...(active && {
            backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: alpha(theme.palette.primary.light, theme.palette.action.selectedOpacity),
            },
        }),
    }}>
        <ListItemText primary={title} primaryTypographyProps={textConfig} />
        { !!badge && <NavBadge label={badge} /> }
    </ListItemButton>
}